module.exports = __webpack_public_path__ + "img/protection.d334cdbf.svg";